import { useEffect, useState } from 'react'
import axios from 'axios'
import { fetchConfuguration, fetchReviews } from 'api/api'
import MasnoryGrid from 'components/MasnoryGrid'
import './App.css'

axios.defaults.baseURL = 'https://dev.useinfluence.co'

function App() {
  const [configurationData, setConfigurationData] = useState()
  const [reviewData, setReviewData] = useState([])
  const [error, setError] = useState(undefined)

  const getUserConfig = async (campaignId, trackingId) => {
    try {
      const data = await fetchConfuguration(campaignId, trackingId)
      setConfigurationData(data.data)
    } catch (err) {
      console.log(err)
      setError('Data not found')
    }
  }

  const getUserReviews = async (campaignId, trackingId) => {
    try {
      const data = await fetchReviews(campaignId, trackingId)
      setReviewData(data.data)
    } catch (err) {
      console.log(err)
      setError('Data not found')
    }
  }

  useEffect(() => {
    const params = window.location.pathname.split('/')
    getUserConfig(params[1], params[2])
    getUserReviews(params[1], params[2])
  }, [])

  useEffect(() => {
    if (configurationData?.theme) {
      window.document.documentElement.classList = configurationData.theme
    }
  }, [configurationData])

  return (
    <div style={{ backgroundColor: configurationData?.backgroundColor }}>
      {error ? (
        <div>
          <p style={{ textAlign: 'center', padding: '16px 0' }}>
            No Data Available
          </p>
        </div>
      ) : (
        <MasnoryGrid reviewsData={reviewData} config={configurationData} />
      )}
    </div>
  )
}

export default App
